import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useOverlayContext } from '~/contexts';
import { OAuthLoginFailure } from './OAuthLoginFailure';
export const useShowOAuthLoginFailure = ()=>{
    const { showModal } = useOverlayContext();
    return useCallback((provider, failure)=>void showModal({
            biName: 'oauth_login_failure',
            biData: {
                provider,
                failure
            },
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(OAuthLoginFailure, {
                    provider: provider,
                    failure: failure,
                    dismissModal: ()=>dismissModal(false)
                });
            }
        }), []);
};
